export function testMethod(param: string) {
    return "Hello " + param;
}